import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Rate } from './Rate'

export const ListOfRateValidation = z.object({
  list: z.instanceof(Rate, { message: '[ListOfRate] list is required' }).array(),
})

export class ListOfRate extends Model {
  static create({ list }: z.infer<typeof ListOfRateValidation>) {
    ListOfRateValidation.parse({ list })
    return new ListOfRate(list)
  }

  constructor(readonly list: Rate[]) {
    super()
  }

  toJSON() {
    return { list: this.list.map(item => item.toJSON()) }
  }

  map<T>(callback: (Rate: Rate, index: number) => T) {
    return this.list.map(callback)
  }

  at(index: number) {
    return this.list.at(index)
  }

  find<T>(callback: (rate: Rate, index: number) => T) {
    return this.list.find((rate, index) => callback(rate, index))
  }

  unique() {
    const seen = new Set<string>()
    const uniqueList = this.list.filter(rate => {
      const { paymentPolicy, cancellationPolicy } = rate.toJSON()
      if (seen.has(`${paymentPolicy.value}-${cancellationPolicy?.fromDate}`)) {
        return false
      }
      seen.add(`${paymentPolicy.value}-${cancellationPolicy?.fromDate}`)
      return true
    })

    return ListOfRate.create({ list: uniqueList })
  }
}
